// extracted by mini-css-extract-plugin
export default {"image":"Y2-z","loaded":"Z2-z"};